import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-department-paused-badge',
  templateUrl: './department-paused-badge.component.html',
  styleUrls: ['./department-paused-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DepartmentPausedBadgeComponent {
  @Input() iconOnly = false;
}
